import Cookies from 'js-cookie'
import axios from 'axios'
import store from './store'
import { mapGetters } from 'vuex'
import * as getters from './store/types/getters'
import $ from 'jquery'
import 'slick-carousel/'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

window.Vue = require('vue')
window.axios = axios

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

import linq from 'linq'
import LoadingView from './components/LoadingView.vue'
import Detail from './components/Detail.vue'
import ProductDetail from './components/products/ProductDetail.vue'
import CartModal from './components/CartModal.vue'
import Cart from './components/Cart.vue'
import sideFilterMethods from './mixin/side-filter-methods'
import cart from './mixin/cart'
import ProfessionalModal from './components/professionalDesign/ProfessionalModal.vue'
import ProfessionalCollectionCart from './components/professionalDesign/ProfessionalCollectionCart'
import ProfessionalCollectionStoreModal from './components/professionalDesign/ProfessionalCollectionStoreModal'
import Howto from './components/Howto'
import AddressSelectModal from './components/AddressSelectModal'
import CheckoutAddressForm from './components/checkout/CheckoutAddressForm'
import Mypage from './components/mypage/Mypage'
import Checkout from './components/checkout/Checkout'
import CheckoutConfirm from './components/checkout/CheckoutConfirm'
import modalUtility from './utility/modalUtility'
import PdfCreate from './components/pdf/PdfCreate'
import OrderDetail from './components/order/OrderDetail'
import OrderDetailEdit from './components/order/OrderDetailEdit'
import { getItems } from './services/CartService'

Vue.mixin(modalUtility)

const lists = {
    LoadingView,
    Detail,
    ProductDetail,
    CartModal,
    Cart,
    ProfessionalModal,
    ProfessionalCollectionCart,
    ProfessionalCollectionStoreModal,
    AddressSelectModal,
    CheckoutAddressForm,
    Howto,
    Mypage,
    Checkout,
    CheckoutConfirm,
    PdfCreate,
    OrderDetail,
    OrderDetailEdit,
}

new Vue({
    el: '#wrapper',
    store,
    data() {
        return {
            product: null,
            colorId: null,
            showModal: false,
            professionalShow: false,
            professionalImage: null,
        }
    },

    created() {
        if (Cookies.get('token')) {
        }
    },

    computed: {
        ...mapGetters({
            user: getters.AUTH_USER,
        }),
    },

    methods: {
        async showProductModal(product, colorId) {
            this.showModal = true
            this.product = product
            if (colorId) {
                this.colorId = colorId
            }
        },
        show(p) {
            this.professionalShow = true
            this.professionalImage = p
        },
        sendOrder() {
            this.sendOrderState = true
        },
    },

    components: {
        ...lists,
    },

    mixins: [sideFilterMethods, cart],
})

if (document.getElementById('cart-dropdown')) {
    window.cartDrop = new Vue({
        data() {
            return {
                showDropDown: false,
                items: [],
                totalPrice: 0,
                loading: true,
                img: '/images/shopping_cart.svg',
            }
        },

        watch: {
            async showDropDown() {
                if (this.showDropDown) {
                    this.getCartItems()
                }
            },
        },

        created() {
            this.getCartItems()
        },

        methods: {
            async getCartItems() {
                this.loading = true
                this.items = await getItems()
                this.setTotalPrice()
                this.img =
                    this.items.length > 0
                        ? '/images/shopping_cart_red.svg'
                        : '/images/shopping_cart.svg'
                this.loading = false
            },

            setTotalPrice() {
                let price = 0
                linq.from(this.items)
                    .select((x) => x.item.price_jpy * x.count)
                    .select((x) => (price += x))
                    .toArray()
                this.totalPrice = Number(price).toLocaleString()
            },

            async deleteCart(index) {
                this.loading = true
                await axios.delete('/api/cart/delete/' + index)
                this.getCartItems()
            },
        },
    }).$mount('#cart-dropdown')

    cartDrop.$on('getCartItems', function () {
        this.getCartItems()
    })
}

export default class Carousel {
    constructor(selector, isTop) {
        this.$el = $(selector)
        if (isTop) {
            this.topSliderConf()
        } else {
            this.init()
        }
    }

    init() {
        this.$el.slick({
            infinite: false,
            dots: true,
            slidesToShow: 8,
            slidesToScroll: 8,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                    },
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                    },
                },
            ],
        })
    }

    topSliderConf() {
        this.$el.slick({
            infinite: true,
            dots: true,
            slidesToShow: 1,
            autoplay: true,
            autoplaySpeed: 5000,
            speed: 1000,
            lazyLoad: 'ondemand',
            centerMode: true,
            centerPadding: '10%',
            arrows: true,
            responsive: [
                {
                    breakpoint: 400,
                    centerPadding: '15px',
                },
            ],
        })
    }
}

new Carousel('.multiple-item')

new Carousel('.top-slider', true)

new Vue({
    el: '#searchBox',
    data() {
        return {}
    },
    methods: {
        openSearch() {
            $('#secret-box').slideToggle()
        },
    },
})



// WEBPACK FOOTER //
// ./resources/assets/js/app.js